import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import "./Classifications.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { END_URL, IMG_URL } from "../../config.js";
import axios from "axios";
import ImageWithLoader from "./ImageWithLoader.jsx";
import loadimg from "../../images/loader_wish.gif";
import gg from "../../images/pp-logo.gif"; // 🧩 Added logo loader
import sg from "../../images/sg.svg";
import { Helmet } from "react-helmet";
import OptimizedCarousel from "./OptimizedCarousel.jsx";

 import Subscriptions from '../Subscriptions/Subscriptions';

const SLIDER_SETTINGS = {
  dots: false,
  infinite: true,
  speed: 600,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  cssEase: "linear",
  centerMode: false,
  variableWidth: false,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: { slidesToShow: 2, slidesToScroll: 2, initialSlide: 2 },
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 1, slidesToScroll: 1 },
    },
  ],
};

function Classifications({ free_test_slug ,token,userdetail,onLoginChange}) {

  const [clusterData, setClusterData] = useState([]);
  const [archeData, setArcheData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  const [openMenus, setOpenMenus] = useState({});

  const [seo, setSeo] = useState({});

  const [loadingBanner, setloadingBanner] = useState(true);

  const faqRef = useRef();
  const menuRef = useRef(null);
  const menuRefs = useRef({});


  const subS = true;

  const [subscription, setSubscription] = useState(null);

  const [ShowModal, setShowModal] = useState(false);

  const [TestLink,setTestLink] = useState(null);

  const [TestLink1,setTestLink1] = useState(null);

  const [TestLink2,setTestLink2] = useState(null);

  const [DetailLink,setDetailLink] = useState(null);
  
   const handleSub = async (subJson) => {

        try {

            setShowModal(true);

            let subIds = subJson;

            if (typeof subJson === "string") {
            try {
                subIds = JSON.parse(subJson);
            } catch (e) {
                console.error("Invalid JSON string for subIds:", e);
                return;
            }
            }

            if (!Array.isArray(subIds) || subIds.length === 0) {
            console.warn("No valid subscription IDs found:", subIds);
            return;
            }

            const res = await axios.post(
            `${END_URL}/sub_adver`,
            { ids: subIds },
            {
                headers: {
                Authorization: `Bearer ${token}`,
                },
            }
            );

            setSubscription(res.data);

        } catch (err) {

            console.error("Error loading subscriptions:", err);
        }
    };

  const handleNavigete = (link) => {
    
    console.log('testt');

    if (link) {
      window.location.href = `/${link}`;
    }
  };

  const LoginShow = () => {

      window.scrollTo({ top: 0, behavior: 'smooth' });
      onLoginChange(true); 
  };

   const LoginShowSub = (subids) => {

      if (subids) {
        try {
          let parsedSubIds;

          if (typeof subids === "string") {
            try {
              parsedSubIds = JSON.parse(subids);
            } catch {
              parsedSubIds = [subids];
            }
          } else if (Array.isArray(subids)) {
            parsedSubIds = subids;
          } else {
            parsedSubIds = [subids];
          }

          localStorage.setItem("pendingSubIds", JSON.stringify(parsedSubIds));
        } catch (error) {
          console.error("Failed to save subids to localStorage:", error);
        }
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
      onLoginChange(true);
  };


  useEffect(() => {

    const fetchTest = async () => {
      try {
        const { data } = await axios.get(`${END_URL}/classifications`,
           {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
 
          setClusterData(data.cluster || []);
          setArcheData(data.areche_type_datas || null);
          setIsLoading(false);
          const seoDate = data.seo_page;
          setSeo(seoDate);

          setTestLink(data?.arche_adver_image_1_link?.slug);

          setTestLink1(data?.arche_adver_image_2_link?.slug);

          setTestLink2(data?.bottom_btn_section_link_2?.slug);

          setDetailLink(data?.detail_link);

      } catch (err) {
        
        console.error("Error fetching data:", err);

      }
    };

    fetchTest();

  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedMenuLink = event.target.closest(".clasi-li-mob1 a");
      if (clickedMenuLink) {
        return;
      }

      const clickedToggle = event.target.closest(".menu-toggle-side");
      const clickedInsideMenu = Object.values(menuRefs.current).some(
        (ref) => ref && ref.contains(event.target)
      );

      if (clickedToggle || clickedInsideMenu) {
        return;
      }

      setOpenMenus({});
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleToggle = useCallback((index) => {
    setOpenMenus((prevState) => {
      if (prevState[index]) {
        return {};
      }

      return { [index]: true };
    });
  }, []);


  return (
    <>
      <Helmet>
        <title>
          {seo?.meta_title ||
            "PersonalityTest - Discover Your True Archetype | Personality Peek"}
        </title>

        <meta
          name="description"
          content={
            seo?.meta_description ||
            "Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey."
          }
        />

        <meta
          name="keywords"
          content={
            seo?.meta_keywords ||
            "personality assessment test , personality test"
          }
        />

        {seo?.og_title && <meta property="og:title" content={seo.og_title} />}
        {seo?.og_description && (
          <meta property="og:description" content={seo.og_description} />
        )}
        {seo?.og_image && (
          <meta property="og:image" content={`${IMG_URL}/d0/${seo.og_image}`} />
        )}
        {seo?.og_url && <meta property="og:url" content={seo.og_url} />}
        {seo?.og_type && <meta property="og:type" content={seo.og_type} />}

        {seo?.twitter_title && (
          <meta name="twitter:title" content={seo.twitter_title} />
        )}
        {seo?.twitter_description && (
          <meta name="twitter:description" content={seo.twitter_description} />
        )}
        {seo?.twitter_image && (
          <meta
            name="twitter:image"
            content={`${IMG_URL}/d0/${seo.twitter_image}`}
          />
        )}
        {seo?.twitter_card && (
          <meta name="twitter:card" content={seo.twitter_card} />
        )}

        {seo?.og_url && <link rel="canonical" href={seo.og_url} />}

        {!seo?.og_title && (
          <meta
            property="og:title"
            content="PersonalityTest - Discover Your True Archetype | Personality Peek"
          />
        )}
        {!seo?.og_description && (
          <meta
            property="og:description"
            content="Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey."
          />
        )}
        {!seo?.og_type && <meta property="og:type" content="website" />}
        {!seo?.twitter_card && (
          <meta name="twitter:card" content="summary_large_image" />
        )}
      </Helmet>

  {isLoading && (
        <div
    className="loadingDiv"
        >
          <img
            src={gg}
            alt="Loading..."
               className=""          />
        </div>
      )}

      <div style={{ visibility: isLoading ? "hidden" : "visible" }}>
        <div className="clasi-main-cont">
          <div className="clasi-all-hints">
       
              <div className="clasi-sub-cont0">
                <div className="container-fluid">
                  <div className={`row clasi-row ${isLoading ? 'load-banner' : ''}`} 
                  
                    style={{
                      background: `url(${IMG_URL}/d0/${archeData?.arche_banner_image}) no-repeat center center`,
                    }}
                  
                  >
                    {!isLoading && (
                      <div className="clasi-fist">
                        {archeData?.arche_type_banner_heading && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: archeData.arche_type_banner_heading,
                            }}
                          />
                        )}

                        <a className="clasi-a" href={`test/${free_test_slug}`}>
                          <span
                            className="clasi-text"
                            dangerouslySetInnerHTML={{
                              __html: archeData?.banner_btn_label,
                            }}
                          />
                          <span className="clasi-icon">
                            <FontAwesomeIcon icon={faArrowRight} />
                          </span>
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
        

            {!isLoading ? (
              clusterData.map((item, i) => (
                <div className={`clasi-sub-cont${i + 1}`} key={item.id || i}>
                  <div className="container">
                    <div className="row clasi-row2-cards">
                      <div className="toggle-side-bars">
                        <span
                          className="menu-toggle-side"
                          onClick={() => handleToggle(i)}
                        >
                          <img src={sg} alt="Sanctum" />
                        </span>

                        <div
                          ref={(el) => (menuRefs.current[`side-${i}`] = el)}
                          className={`toggle-menu-list-box ${
                            openMenus[i] ? "open" : ""
                          }`}
                        >
                          <ul className="clasi-li-mob1">
                            <h5>{item?.name}</h5>
                            {item.dimension?.map((value, j) => (
                              <li key={value.slug || j}>
                                <a href={`/${DetailLink}/${value?.slug}`}>
                                  {value?.name}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>

                      <div className="col-12 col-md-3 clas-side-menu">
                        <div
                          ref={(el) => (menuRefs.current[`side-${i}`] = el)}
                          className={`clasi-mob-side ${
                            openMenus[i] ? "open" : ""
                          }`}
                        >
                          <ul className="clasi-li-mob">
                            <h5>{item?.name}</h5>
                            {item.dimension?.map((value, j) => (
                              <li key={value.slug || j}>
                                <a href={`/${DetailLink}/${value?.slug}`}>
                                  {value?.name}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>

                        <ul className="clasi-li">
                          <h5>{item?.name}</h5>
                          {item.dimension?.map((value, j) => (
                            <li key={value.slug || j}>
                              <a href={`/${DetailLink}/${value?.slug}`}>
                                {value?.name}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="col-12 col-md-9">
                        <div className="row clas-row2-title">
                          <div className="clasi-row2-title-div">
                            <h2>{item?.name}</h2>
                            <p className="cluster-des">
                              {item?.cluster_description}
                            </p>
                          </div>
                        </div>

                        <OptimizedCarousel
                          item={item}
                          clusterIndex={i}
                          clusterData={clusterData}
                          IMG_URL={IMG_URL}
                          loadimg={loadimg}
                          DetailLink={DetailLink}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="skeleton3 skldivs test sklfluid-m"></div>
            )}
          </div>

          <div className="classi-accordion-div">
            {isLoading ? (
              <div className="skeleton3 skldivs sklfluid-m-all"></div>
            ) : (
              <div className="container">
                <div className="row gy-4">
                  {archeData?.arche_adver_image_1 && (
                    <div
                      className="col-12 col-sm-12 col-md-2"

                      onClick={
                        token
                          ? (TestLink != "" && TestLink != null 
                              ? () => handleNavigete(TestLink)
                              : () => handleSub(archeData.arche_adver_image_1_link))
                          : () => LoginShowSub(archeData.arche_adver_image_1_link)
                      }
                    >
                      <div className="class-advert tet">
                        <img
                          src={`${IMG_URL}/d0/${archeData.arche_adver_image_1}`}
                          alt="Decode your inner darkness. Learn your dark archetype."
                        />
                      </div>
                    </div>
                  )}

                  <div className="col-12 col-sm-12 col-md-4">
                    <div className="arch-bottom-btn">
                      {archeData?.bottom_title_section_1 && (
                        <p
                          dangerouslySetInnerHTML={{
                            __html: archeData.bottom_title_section_1,
                          }}
                        />
                      )}

                      <a
                        className="home-slider-sun-box-a"
                        href={archeData?.bottom_btn_section_link_1 || "#"}
                        rel="noopener noreferrer"
                        style={{
                                // marginTop: '0px',

                                // '--full_trait_button_color': '#8e639b',
                                // '--full_trait_button_color': '#8e639b',
                                // '--full_trait_button_color_hover':'#8e639b',
                                // '--luminus_button_color_15': '#8e639b',
                                // '--luminus_button_color_25': '#8e639b',
                                // '--luminus_button_color_38': '#8e639b',
                                // '--luminus_button_color_45': '#8e639b',
                                // '--luminus_button_color_50': '#8e639b',
                                // '--luminus_button_color_55': '#8e639b',
                                // '--luminus_button_color_70': '#8e639b',
                                // '--luminus_button_color_85': '#8e639b',
                                // '--luminus_button_color_92': '#8e639b',
                                // '--luminus_button_color_100':'#8e639b',
                            }}

                      >
                        <span className="home-slider-sun-box-a-text">
                          {archeData?.bottom_btn_section_1}
                        </span>
                        <span className="home-slider-sun-box-a-icon">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                      </a>
                    </div>
                  </div>

                  <div className="col-12 col-sm-12 col-md-4">
                    <div className="arch-bottom-btn 64arche">
                      {archeData?.bottom_title_section_2 && (
                        <p
                          dangerouslySetInnerHTML={{
                            __html: archeData.bottom_title_section_2,
                          }}
                        />
                      )}

                      <a
                        className="home-slider-sun-box-a"

                        // href={archeData?.bottom_btn_section_link_2 || "#"}
                        onClick={
                          token
                            ? (TestLink2 != "" && TestLink2 != null
                                ? () => handleNavigete(TestLink2)
                                : () => handleSub(archeData.bottom_btn_section_link_2))
                            : () => LoginShowSub(archeData.bottom_btn_section_link_2)
                        }

                        rel="noopener noreferrer"
                      >
                        <span className="home-slider-sun-box-a-text">
                          {archeData?.bottom_btn_section_2}
                        </span>
                        <span className="home-slider-sun-box-a-icon">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                      </a>
                    </div>
                  </div>

                  {archeData?.arche_adver_image_2 && (
                    <div
                      className="col-12 col-sm-12 col-md-2"

                      onClick={
                        token
                          ? (TestLink1 != "" && TestLink1 != null
                              ? () => handleNavigete(TestLink1)
                              : () => handleSub(archeData.arche_adver_image_2_link))
                          : () => LoginShowSub(archeData.arche_adver_image_2_link)
                      }
                    >
                      <div className="class-advert">
                        <img
                          src={`${IMG_URL}/d0/${archeData.arche_adver_image_2}`}
                          alt="Dive into your inner shadows. Reveal your dark archetype."
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

       {ShowModal && (
                                  
          <div 
                  className={`newdashpop-overlay subs-cognit-modal1 modal_subcript ${
                   subscription?.data?.length == 1 ? "single-subscription" : ""
                  }`}
                
                >

                  <div className="newdashpop-inner">

                      <div className="newdashpop-container">

                          <button
                            className="newdashpop-close"
                            onClick={() => setShowModal(false)}
                            >
                            &times;
                        </button>

                        <div className="conent-pop">
                        
                           <Subscriptions subs={subS} userdetail={userdetail} Subcription={subscription} onLoginChange={onLoginChange}/>

                        </div>

                      </div>

                  </div>

              </div>
          )}
    </>
  );
}

export default React.memo(Classifications);
